<template>
  <Popup class="payment-detail-popup" v-model="show" :title="text.offer_detail">
    <div
      :class="['payment-detail-body', isTurbo ? 'payment-detail-body-gt' : '']"
    >
      <!-- 明细 -->
      <div class="detail">
        <!-- 原价 -->
        <CardItem :title="text.originalPriceText" :amount="hackOriginalPrice" />
        <!-- 优惠券 -->
        <CardItem
          :title="text.coupon"
          :amount="choiceCouponMoney"
          :isDiscount="true"
          :showArrow="isRenderShowArrow"
          :loading="loading"
          :showCountdown="countdownData.show"
          :userCouponExpireTime="countdownData.time"
          @handleArrow="switchCouponList"
        />
        <!-- 其他优惠 -->
        <CardItem
          :title="text.special_offer"
          :isDiscount="true"
          :amount="discountAmount"
        />
      </div>
      <div
        :class="bindDividingClass"
        :style="{ borderColor: bindCardTitleStyle }"
      ></div>
      <!-- 汇总 -->
      <div class="total">
        <!-- 共减 -->
        <CardItem
          :title="text.total_discount"
          :isDiscount="true"
          :amount="totalDiscount"
        />
        <!-- 优惠后价格 -->
        <CardItem :title="text.finail_price" :amount="hackCouponAfterMoney" />
      </div>
    </div>
  </Popup>
</template>
<script>
  // 支付明细
  import Popup from '../Popup'
  import CardItem from './CardItem'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { sub } from '@/utils/accurateNumber'
  import { mapState, mapMutations, mapGetters } from 'vuex'
  import { isNewGenshin } from '../utils'

  export default {
    mixins: [styleConfiguration],
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      discountAmount: {
        type: Number,
        default: 0,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      // 选中优惠券的金额
      choiceCouponMoney: {
        type: Number,
        default: 0,
      },
      couponAfterMoney: {
        type: [String, Number],
        default: 0,
      },
      selectedCoupons: {
        type: Array,
        default: () => [],
      },
      countdownData: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      Popup,
      CardItem,
    },
    data() {
      return {
        show: this.value,
      }
    },
    computed: {
      ...mapState(['selectedSkuInfo', 'gameName', 'isTurbo']),
      ...mapState('detail', ['selectSkuItem', 'selectChannelItem']),
      ...mapGetters(['isLogin', 'isAllExternalGames']),
      ...mapGetters('detail', ['gameCouponList']),

      // 优惠券是否展示箭头
      isRenderShowArrow() {
        if (!this.isLogin) return false
        return !!this.gameCouponList.length
      },
      hackOriginalPrice() {
        if (this.isAllExternalGames) {
          return this.selectSkuItem.skuPrice || 0
        }
        return this.selectSkuItem.originalPrice
      },
      bindDividingClass() {
        const classList = ['dividing-line', 'limit-game-desc']
        return classList
      },
      bindCardTitleStyle() {
        if (isNewGenshin(this.gameName)) return '#93735C'
        return this.priceColor.color
      },
      text() {
        // 文案
        return {
          originalPriceText: this.$t('common.originalPriceText'),
          offer_detail: this.$t('coupon.offer_detail'),
          coupon: this.$t('coupon.coupon'),
          special_offer: this.$t('coupon.special_offer'),
          total_discount: this.$t('coupon.total_discount'),
          finail_price: this.$t('coupon.finail_price'),
        }
      },
      totalDiscount() {
        // 共减----数值=优惠券数值+其他优惠数值
        return this.choiceCouponMoney + this.discountAmount
      },
      // todo 融合逻辑【兼容】
      // 新版的万岁爷传递的方式vuex、
      // 旧版的是 emit
      hackCouponAfterMoney() {
        const { channelPrice = 0 } = this.selectChannelItem
        const _totalDiscount = this.choiceCouponMoney
        let price = 0
        const couponAfterMoney = this.couponAfterMoney

        if (isNewGenshin(this.gameName)) return couponAfterMoney
        // 如果没有配置支付通道的时候、那么默认就是0
        if (channelPrice === 0) {
          price = 0
        } else if (this.isLogin) {
          price = sub(channelPrice, _totalDiscount)
        } else {
          price = channelPrice
        }
        return price
      },
    },
    watch: {
      // 监听优惠券价格
      hackCouponAfterMoney: {
        handler(newVal) {
          this['detail/setCalfinalPrice'](newVal)
        },
        immediate: true,
      },
      value(val) {
        this.show = val
        this.setWatchCouponState(val)
      },
      show(val) {
        this.$emit('input', val)
      },
    },
    methods: {
      ...mapMutations(['detail/setCalfinalPrice', 'setWatchCouponState']),
      switchCouponList() {
        // 优惠券列表展示切换
        this.$emit('switchCouponList')
      },
    },
  }
</script>
<style lang="scss" scoped src="./index.scss"></style>
